export type SourceOfDiscoveryOption = {
  value: string
  label: string
};

export const SOURCE_OF_DISCOVERY_OPTIONS: SourceOfDiscoveryOption[] = [
  { value: 'Instagram', label: 'Instagram' },
  { value: 'Facebook', label: 'Facebook' },
  { value: 'Google', label: 'Google' },
  { value: 'Referral', label: 'Referral' },
  { value: 'Other', label: 'Other' },
];
